import { VER, UNV, WRN, ERR } from '../../enums/address-verification-status';

export const isAddressVerified = (verificationStatus) => VER === verificationStatus;

export const isAddressInErrorOrWarningState = (verificationStatus) => {
  return verificationStatus === ERR || verificationStatus === WRN;
};

export const isAddressUnVerified = (verificationStatus) => !verificationStatus || verificationStatus === UNV;
